import axios from '@/utils/axios'

const selOrderList = (data = {}, config) => axios.post('/api/v1/pc/orderInfo', data, config)
const orderDetails = (orderNo, query, config) => axios.get(`/api/v1/pc/order/detailed/${orderNo}`, query, config)
const getTradeCode = (data = {}, config) => axios.post('/api/v1/pc/toTrade', data, config)
const createOrder = (data = {}, config) => axios.post('/api/v1/pc/order', data, config)
const payOrder = (data = {}, config) => axios.post('/api/v1/pc/order/pay', data, config)
const savePayCertificates = (data = {}, config) => axios.post('/api/v1/pc/savePayCertificates', data, config)

const freight = (data = {}, config) => axios.post('/api/v1/pc/common/freight', data, config)

const queryPayResult = (orderNo, query, config) => axios.get(`/api/v1/pc/pay/result/${orderNo}`, query, config)
export default {
  selOrderList,
  orderDetails,
  getTradeCode,
  createOrder,
  payOrder,
  savePayCertificates,
  freight,
  queryPayResult
}


// WEBPACK FOOTER //
// ./src/api/modules/order.js